import PuzzleWalls from './Root.vue';
import PuzzleWallsCreate from './views/PuzzleWallsCreate.vue';
import PuzzleWallsEdit from './views/PuzzleWallsEdit.vue';
import PuzzleWallsList from './views/PuzzleWallsList.vue';

export default {
  path: 'gerador/walls',
  name: 'admin-puzzle-walls',
  component: PuzzleWalls,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-walls-list',
      component: PuzzleWallsList,
    },
    {
      path: 'novo/',
      name: 'admin-puzzle-walls-new',
      component: PuzzleWallsCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-walls-edit',
      component: PuzzleWallsEdit,
    },
  ],
};
